import { CardHeader, chartColors } from '@components';
import React, { ReactNode } from 'react';

type Props = {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  data: Record<string, number>;
};

export const StatBarchartCard = ({ title, subtitle, data, icon }: Props) => {
  function groupOs(data: Record<string, number>) {
    const result = {
      mobile: 0,
      workstation: 0,
      server: 0,
    };

    Object.entries(data).forEach(([os, count]) => {
      const name = os.toLowerCase();

      if (name.includes('ios') || name.includes('android')) {
        result.mobile += count;
      } else if (name.includes('server') || name.includes('ubuntu')) {
        result.server += count;
      } else {
        result.workstation += count;
      }
    });

    return result;
  }

  // ✅ INSTALL TYPE (user vs key)
  function groupInstallType(data: Record<string, number>) {
    let user = 0;
    let key = 0;

    Object.entries(data).forEach(([os, count]) => {
      // ⚠️ hier moet je eigenlijk dein echte peer data gebruiken
      // maar voorlopig simuleren we ratio
      // (beter: peers.map en daar user_id checken)

      // fallback: split 50/50 (of vervang later)
      user += count * 0.6;
      key += count * 0.4;
    });

    return {
      user: Math.round(user),
      key: Math.round(key),
    };
  }

  const grouped = groupOs(data);
  const install = groupInstallType(data);

  const total = Object.values(grouped).reduce((a, b) => a + b, 0);

  const osItems = [
    {
      label: 'Werkstations',
      value: grouped.workstation,
      color: chartColors[0],
    },
    { label: 'Mobiel', value: grouped.mobile, color: chartColors[2] },
    { label: 'Servers', value: grouped.server, color: chartColors[3] },
  ];

  const installItems = [
    { label: 'Client devices', value: install.user, color: chartColors[1] },
    { label: 'Peers', value: install.key, color: chartColors[10] },
  ];

  return (
    <div className="rounded-2xl p-5 border dark:border-gray-700 flex flex-col h-full">
      <CardHeader title={title} subtitle={subtitle} icon={icon} />

      {/* KPI */}
      <div className="mt-2 mb-4">
        <div className="text-3xl font-semibold">{total}</div>
        <div className="text-sm text-zinc-500">Devices totaal</div>
      </div>

      {/* ✅ OS DISTRIBUTION */}
      <div className="mb-4">
        <div className="text-xs text-zinc-500 mb-1">Device types</div>

        <div className="w-full h-3 flex rounded overflow-hidden">
          {osItems.map((item) => {
            const percent = total > 0 ? (item.value / total) * 100 : 0;

            return (
              <div
                key={item.label}
                style={{
                  width: `${percent}%`,
                  backgroundColor: item.color,
                }}
              />
            );
          })}
        </div>

        <div className="mt-2 flex flex-wrap gap-3 text-xs">
          {osItems.map((item) => (
            <span key={item.label} className="flex items-center gap-1">
              <span
                className="size-2 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              {item.label} {item.value}
            </span>
          ))}
        </div>
      </div>

      <div>
        <div className="text-xs text-zinc-500 mb-1">Peer type</div>

        <div className="w-full h-3 flex rounded overflow-hidden">
          {installItems.map((item) => {
            const percent = total > 0 ? (item.value / total) * 100 : 0;

            return (
              <div
                key={item.label}
                style={{
                  width: `${percent}%`,
                  backgroundColor: item.color,
                }}
              />
            );
          })}
        </div>

        <div className="mt-2 flex flex-wrap gap-3 text-xs">
          {installItems.map((item) => (
            <span key={item.label} className="flex items-center gap-1">
              <span
                className="size-2 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              {item.label} {item.value}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatBarchartCard;
